// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"DropdownItem_MenuItem__oWsUw","MenuItemActive":"DropdownItem_MenuItemActive__wJf_8"};